export default __webpack_public_path__ + "static/media/confirmation.8a62356f.svg";